<template>
  <div class="gardenFireControlList">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <el-button type="primary" style="float:right;margin-bottom:10px;" @click="add">新增</el-button>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="deviceNum" label="设备编号"></el-table-column>
        <el-table-column prop="deviceName" label="设备别名"></el-table-column>
        <el-table-column prop="deviceType" label="设备类别">
          <template slot-scope="scope">
            <span v-if="scope.row.deviceType == 1">消防水池</span>
            <span v-if="scope.row.deviceType == 2">水泵</span>
            <span v-if="scope.row.deviceType == 3">消防监控室</span>
          </template>
        </el-table-column>
        <el-table-column prop="operationDate" label="投运时间"></el-table-column>
        <el-table-column prop="useDate" label="使用时间"></el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 新增小区消防设备信息弹窗 -->
    <el-dialog title="小区消防设备设施信息" :visible.sync="dialogVisible" :close-on-click-modal="false" center top="130px"
      width="900px">
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws13" :label-suffix="require('@/config/enum').c_colon">

        <el-form-item tem label="设备编号" prop="deviceNum">
          <el-input v-model="ruleForm.deviceNum" placeholder="请输入" class="item-input" style="width:90%" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="设备类别" prop="deviceType">
          <el-select v-model="ruleForm.deviceType" placeholder="请选择" style="width:90%">
            <el-option v-for="item in deviceType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="产权单位" prop="deviceUnit">
          <el-input v-model="ruleForm.deviceUnit" placeholder="请输入" class="item-input" style="width:90%" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="设备别名" prop="deviceName">
          <el-input v-model="ruleForm.deviceName" placeholder="请输入" class="item-input" style="width:90%" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="投运时间" prop="operationDate">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="ruleForm.operationDate" style="width:90%">
          </el-date-picker>
        </el-form-item>
        <el-form-item tem label="使用年限" prop="useAge">
          <el-input v-model="ruleForm.useAge" placeholder="请输入" class="item-input" type="number" style="width:90%"
            maxlength="3">
          </el-input>
        </el-form-item>
        <el-form-item label="使用时间" prop="useDate">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="ruleForm.useDate" style="width:90%"></el-date-picker>
        </el-form-item>
        <el-form-item tem label="微型消防站数量(个)" prop="fireStationNum">
          <el-input v-model="ruleForm.fireStationNum" placeholder="请输入" class="item-input" type="number" style="width:90%">
          </el-input>
        </el-form-item>
        <el-form-item tem label="喷淋设备数量(个)" prop="sprayDeviceNum">
          <el-input v-model="ruleForm.sprayDeviceNum" placeholder="请输入" class="item-input" type="number" style="width:90%">
          </el-input>
        </el-form-item>
        <el-form-item tem label="消防监控摄像头数量(个)" prop="cameraNum">
          <el-input v-model="ruleForm.cameraNum" placeholder="请输入" class="item-input" type="number" style="width:90%">
          </el-input>
        </el-form-item>
        <el-form-item tem label="消防栓数量(个)" prop="fireHydrantNum">
          <el-input v-model="ruleForm.fireHydrantNum" placeholder="请输入" class="item-input" type="number" style="width:90%">
          </el-input>
        </el-form-item>
        <el-form-item tem label="消防车通道数量(个)" prop="fireEngineAccessNum">
          <el-input v-model="ruleForm.fireEngineAccessNum" placeholder="请输入" class="item-input" type="number" style="width:90%">
          </el-input>
        </el-form-item>
        <el-form-item tem label="消防车通道警示标志、标识数量(个)" prop="fireEngineAccessSignNum">
          <el-input v-model="ruleForm.fireEngineAccessSignNum" placeholder="请输入" class="item-input" type="number" style="width:90%">
          </el-input>
        </el-form-item>
        <div class="jump-btn" style="text-align:center">
          <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
            保存
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:gardenFireControlList
   *@Description:小区消防信息
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        deviceType: this.$i18n.t('lang.FireControlDeviceTypeDeviceType'),
        saveData: '',
        isDisabled: true,
        id: '', // 消防信息id
        tableData: [], // 消防设备信息list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        dialogVisible: false, // 新增弹窗状态
        rules: {
          deviceNum: [{
            required: true,
            message: '请输入设备编号',
            trigger: 'blur'
          }],
          deviceType: [{
            required: true,
            message: '请选择设备类别',
            trigger: 'change'
          }],
          deviceUnit: [{
            required: true,
            message: '请输入产权单位',
            trigger: 'blur'
          }],
          deviceName: [{
            required: true,
            message: '请输入设备别名',
            trigger: 'blur'
          }],
          operationDate: [{
            required: true,
            message: '请选择投运时间',
            trigger: 'change'
          }],
          useAge: [{
            required: true,
            message: '请输入使用年限',
            trigger: 'blur'
          }],
          useDate: [{
            required: true,
            message: '请选择使用时间',
            trigger: 'change'
          }],
          fireStationNum: [{
            required: true,
            message: '请输入微型消防站数量',
            trigger: 'blur'
          }],
          sprayDeviceNum: [{
            required: true,
            message: '请输入喷淋设备数量',
            trigger: 'blur'
          }],
          cameraNum: [{
            required: true,
            message: '请输入消防监控摄像头数量',
            trigger: 'blur'
          }],
          fireHydrantNum: [{
            required: true,
            message: '请输入消防栓数量',
            trigger: 'blur'
          }],
          fireEngineAccessNum: [{
            required: true,
            message: '请输入消防车通道数量',
            trigger: 'blur'
          }],
          fireEngineAccessSignNum: [{
            required: true,
            message: '请输入消防车通道警示标志、标识数量',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          deviceNum: '', // 设备编号
          deviceType: '', // 设备类别
          deviceUnit: '', // 产权单位
          deviceName: '', // 设备别名
          operationDate: '', // 投运时间
          useAge: '', // 使用年限
          useDate: '', // 使用时间
          fireStationNum: '', // 微型消防站数量
          sprayDeviceNum: '', // 喷淋设备数量
          cameraNum: '', // 消防监控摄像头数量
          fireHydrantNum: '', // 消防栓数量 
          fireEngineAccessNum: '', // 消防车通道数量
          fireEngineAccessSignNum: '', // 消防车通道警示标志、标识数量
        },
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      this.getData()
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      // 获取消防设备信息列表
      getData() {
        let loading = this.$loading()
        this.$get(`/gardenDrawGardenFire?gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 新增消防设备信息
      add() {
        this.id = ''
        this.ruleForm.deviceNum = ''
        this.ruleForm.deviceType = ''
        this.ruleForm.deviceUnit = ''
        this.ruleForm.deviceName = ''
        this.ruleForm.operationDate = ''
        this.ruleForm.useAge = ''
        this.ruleForm.useDate = ''
        this.ruleForm.fireStationNum = ''
        this.ruleForm.sprayDeviceNum = ''
        this.ruleForm.cameraNum = ''
        this.ruleForm.fireHydrantNum = ''
        this.ruleForm.fireEngineAccessNum = ''
        this.ruleForm.fireEngineAccessSignNum = ''
        this.dialogVisible = true
      },
      // 编辑消防设备信息
      edit(rowData) {
        this.id = rowData.id
        this.ruleForm.deviceNum = rowData.deviceNum
        this.ruleForm.deviceType = rowData.deviceType
        this.ruleForm.deviceUnit = rowData.deviceUnit
        this.ruleForm.deviceName = rowData.deviceName
        this.ruleForm.operationDate = rowData.operationDate
        this.ruleForm.useAge = rowData.useAge
        this.ruleForm.useDate = rowData.useDate
        this.ruleForm.fireStationNum = rowData.fireStationNum
        this.ruleForm.sprayDeviceNum = rowData.sprayDeviceNum
        this.ruleForm.cameraNum = rowData.cameraNum
        this.ruleForm.fireHydrantNum = rowData.fireHydrantNum
        this.ruleForm.fireEngineAccessNum = rowData.fireEngineAccessNum
        this.ruleForm.fireEngineAccessSignNum = rowData.fireEngineAccessSignNum
        this.saveData = JSON.stringify(this.ruleForm)
        this.dialogVisible = true
      },
      // 删除消防设备信息
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/gardenDrawGardenFire/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.getData()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        let params = this.ruleForm
        params.gardenId = this.gardenId
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.id) {
              // 新增
              this.$post('/gardenDrawGardenFire', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.getData()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/gardenDrawGardenFire/${this.id}`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.getData()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })

        this.dialogVisible = false
        this.ruleForm.deviceNum = ''
        this.ruleForm.deviceType = ''
        this.ruleForm.deviceUnit = ''
        this.ruleForm.deviceName = ''
        this.ruleForm.operationDate = ''
        this.ruleForm.useAge = ''
        this.ruleForm.useDate = ''
        this.ruleForm.fireStationNum = ''
        this.ruleForm.sprayDeviceNum = ''
        this.ruleForm.cameraNum = ''
        this.ruleForm.fireHydrantNum = ''
        this.ruleForm.fireEngineAccessNum = ''
        this.ruleForm.fireEngineAccessSignNum = ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    },
  }
</script>

<style lang="scss">
  .gardenFireControlList {}
</style>